// App.js
import React, { useEffect, useState } from "react"
import ImageTextEditor from "./pages/ImageTextEditor"
import "./styles/ImageTextEditor.css"
import { getSettings } from "./services/bannerService"
import { Outlet, useNavigate, useSearchParams } from "react-router-dom"
import { Slide, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
// Stores
import settingsStore from "./stores/settingsStore"
import bannersStore from "./stores/bannersStore"
import botStore from "./stores/botStore"
import { initializeToken } from "./services/apiHelper"
import { API_URL } from "./services/constants"
import "./styles/fonts.css"

function App() {
    const [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate()
    const setSettings = settingsStore((state) => state.setSettings)
    const settings = settingsStore((state) => state.settings)
    const setBanners = bannersStore((state) => state.setBanners)
    const setBot = botStore((state) => state.setBot)

    const token = searchParams.get("token") || localStorage.getItem("token")

    useEffect(() => {
        if (token) {
            initializeToken(token)
            getSettings()
                .then((response) => {
                    navigate("/banners", { replace: true })
                    setBot(response.data.bot)
                    setBanners(
                        response.data.botBanners.map((banner) => ({
                            ...banner,
                            url: `${API_URL}/static/${response.data.bot.templateName}:${banner.id}`,
                        }))
                    )
                    setSettings(response.data.settings)
                    localStorage.setItem("token", token)
                })
                .catch(() => {})
        }
    }, [token])

    if (!token || !settings) {
        return "Access Denied"
    }

    return (
        <div className="App">
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                draggable
                transition={Slide}
                theme="dark"
            />

            <Outlet />
        </div>
    )
}

export default App
